export default __webpack_public_path__ + "static/media/4.257a0db3.jpg";